import React from "react";
import ErrorImage from "../assets/error-page.svg";

const ErrorPage = ({ resetErrorBoundary }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "5rem",
        maxHeight: "100vh",
      }}
    >
      <img
        style={{ width: "40%", height: "auto", marginBottom: "1rem" }}
        src={ErrorImage}
        alt="Page not found"
      />
      <p
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          alignItems: "center",
          fontWeight: "bold",
          gap: "1rem",
        }}
      >
        Something went wrong. Try clicking the refresh page button to reload the
        application.{" "}
        <button
          style={{
            width: "fit-content",
            border: "none",
            padding: "5px 10px",
            background: "#bd1d3d",
            color: "#fff",
            letterSpacing: "1px",
            borderRadius: "5px",
            fontSize: "18px",
          }}
          onClick={resetErrorBoundary}
        >
          Refresh page
        </button>
      </p>
    </div>
  );
};

export default ErrorPage;
